<template>
  <v-dialog :value="value" max-width="650px" persistent @input="$emit('input', $event)">
    <v-card class="pa-6">
      
      <h2 class="font-weight-bold mb-1 text-left">Redefinir Senha</h2>
      
      <p class="subtitle text-left mb-6">
        Informe o código recebido no e-mail e defina sua nova senha.
      </p>

      <v-form ref="form" @submit.prevent="submit">
        <v-row>
          
          <v-col cols="12">
            <v-text-field 
              v-model="code" 
              label="Código de Verificação" 
              outlined 
              dense
              hide-details="auto" 
              :rules="[rules.required]" 
            />
          </v-col>

          <v-col cols="12">
            <v-text-field 
              v-model="password" 
              label="Nova senha" 
              type="password" 
              outlined 
              dense
              hide-details="auto" 
              :rules="[rules.required, rules.min]" 
            />
          </v-col>

          <v-col cols="12">
            <v-text-field 
              v-model="passwordConfirm" 
              label="Confirmar nova senha" 
              type="password" 
              outlined 
              dense
              hide-details="auto" 
              :rules="[rules.required, matchPassword]" 
            />
          </v-col>

        </v-row>

        <v-row dense class="mt-4">
          
          <v-col cols="12" md="6">
            <v-btn
              outlined
              large
              block
              @click="$emit('input', false)"
              :disabled="loading"
            >
              Cancelar
            </v-btn>
          </v-col>

          <v-col cols="12" md="6">
            <v-btn
              color="primary"
              large
              block
              type="submit"
              :loading="loading"
            >
              Redefinir
            </v-btn>
          </v-col>

        </v-row>
      </v-form>

    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "ResetPasswordWithCode",

  props: {
    value: Boolean,
    email: String,
    type: {
      type: Number,
      default: 1
    }
  },

  data: () => ({
    loading: false,
    code: "",
    password: "",
    passwordConfirm: "",
    rules: {
      required: v => !!v || "Campo obrigatório.",
      min: v => (v && v.length >= 6) || "Mínimo 6 caracteres."
    }
  }),

  methods: {

    matchPassword(v) {
      return v === this.password || "Senhas não conferem.";
    },

    async submit() {

      if (!this.$refs.form.validate()) return;

      this.loading = true;

      try {

        await axios.post("/api/users/reset-password", {
          email: this.email,
          type: this.type,
          code: this.code,
          newPassword: this.password
        });

        this.$emit("success");

      } catch (error) {

        this.$dialog.notify.error(
          this.$codes(error),
          { position: 'top-right', timeout: 5000 }
        );

      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.subtitle {
  font-size: 14px;
  opacity: 0.9;
  color: #555;
}
</style>
